export default __webpack_public_path__ + "static/media/jnoon_animatedLoading.ad33b767.gif";